import React from 'react';
import css from './Link.css';

export default class ReturnLink extends React.Component {

  render() {
    return <a href="#" className={css['link']}>Return to the main Services page</a>;
  }
}
